var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goals__container"},[(_vm.profile.role === 'superadmin' || _vm.profile.isSpecialFunctions)?_c('AdminSection'):_vm._e(),(_vm.profile.role === 'monitor')?_c('MonitorSection'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }